import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getBookFlashCardInfo = ({ courseId, bookId }) =>
  httpClient.get(`${apis.GET_BOOK_FLASH_CARD_INFO}/${courseId}/${bookId}`);
export const getBookFlashCardFilter = ({ cardId }) =>
  httpClient.get(`${apis.GET_BOOK_FLASH_CARD_FILTER}/${cardId}`);
export const sequenceFlashCardList = (payload) =>
  httpClient.post(apis.SEQUENCE_BOOK_FLASH_CARD_LIST, { ...payload }, { ignore: true });
export const randomFlashCardList = (payload) =>
  httpClient.post(apis.RANDOM_BOOK_FLASH_CARD_LIST, { ...payload }, { ignore: true });
export const getReviseFlashCardList = ({ cardId }) =>
  httpClient.get(`${apis.GET_REVISE_BOOK_FLASH_CARD_LIST}/${cardId}`);
export const getFavoriteFlashCardList = ({ cardId }) =>
  httpClient.get(`${apis.GET_FAVORITE_BOOK_FLASH_CARD_LIST}/${cardId}`);
export const getFavoriteCourseFlashCardList = ({ courseId }) =>
  httpClient.get(`${apis.GET_FAVORITE_COURSE_FLASH_CARD_LIST}/${courseId}`);
export const getFlashCardDetail = ({ cardDetailId, readingId, addQuestion }) =>
  httpClient.get(`${apis.GET_FLASH_CARD_DETAIL}/${readingId}/${cardDetailId}`, {
    params: { addQuestion },
  });
export const answerFlashCard = (payload) =>
  httpClient.post(apis.ANSWER_FLASH_CARD, { ...payload }, { ignore: true });
export const toggleFavoriteFlashCard = ({ cardId, cardDetailId, readingId, favorite }) =>
  httpClient.post(
    `${apis.TOGGLE_FAVORITE_FLASH_CARD}/${cardId}/${cardDetailId}`,
    { readingId, favorite },
    { ignore: true }
  );
export const toggleFlashCardAddQuestionSequence = ({ cardId, addQuestion }) =>
  httpClient.post(
    `${apis.TOGGLE_FLASH_CARD_ADD_QUESTION_SEQUENCE}/${cardId}`,
    { addQuestion },
    { ignore: true }
  );
export const toggleFlashCardAddQuestionRandom = ({ cardId, addQuestion }) =>
  httpClient.post(
    `${apis.TOGGLE_FLASH_CARD_ADD_QUESTION_RANDOM}/${cardId}`,
    { addQuestion },
    { ignore: true }
  );

export const flashCardReport = (payload) =>
  httpClient.post(apis.POST_FLASH_CARD_REPORT, { ...payload }, { ignore: true });
